import React, { useEffect, useRef, useState } from "react";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import {
  appUserInfoList,
  appDetail,
  appEditUser,
  appEditAppUserTeamAttribute,
  appUserInfoResetAppUserPwd,
  getLinkDetail,
  getOperationAuthDetail,
  editAppUserDeviceFlowReward,
  appEditAccount,
  changeParent,
  editAppUserBuTie,
} from "@/api/operation";
import { Button, Form, Input, message, Modal, Space, Switch, Tag } from "antd";
import {
  customRequest,
  setIcons,
  normFile,
  resetForm,
  getTimeFormat,
  getFirstDay,
  showModal,
} from "@/utils/common";
import { useSelector, useDispatch, useStore } from "react-redux";
import { dictInfoAsync } from "@/stores/dictInfo";
import IForm from "@/components/i-form/i-form";
import { decimalReg } from "@/utils/regs";
import { columns, linkColumns, formTab, amountType,modalFormTab } from "./helps";
import { useCascader } from "@/hooks/useCascader";
import { channelLevelAreaTree, areaTree } from "@/api/setting";
import dayjs from "dayjs";
import TeamPerformance from "./components/teamPerformance";

const flowingShareholders_options = [
  {
    label: "是",
    value: "1",
  },
  {
    label: "否",
    value: "0",
  },
];

const AppUserInfo = () => {
  const dispatch = useDispatch();
  const {
    state: { providers_level, account_changes_business_type },
  } = useSelector((state: { dictInfo: any }) => state.dictInfo);
  const [pageData, setPageData] = useState<SelectCmsAppUserPageRes["rows"]>([]);
  const [userOutPageData, setUserOutPageData] = useState<
    ListUserAccountChangesByIdRes["rows"]
  >([]);
  const [mainPicUploadProgress, setMainPicUploadProgress] = useState(false);
  const [editPriceForm] = Form.useForm();
  const [total, setTotal] = useState(0);
  const [userOutTotal, setUserOutTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [userOutopen, setuserOutOpen] = useState(false);
  const [eidtUserOpen, setEidtUserOpen] = useState(false);
  const [editPriceDisabled, setEditPriceDisabled] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [addMoneyLoading, setAddMoneyLoading] = useState(false);

  const [modalFormData, setModalFormData] = useState<pageHomeAddParams>({
    accountType: "3",
  });

  const { cascaderProps, loadByIds } = useCascader({
    fetchData: areaTree as any,
    initId: [100000],
  });

  const [formData, setFormData] = useState<SelectCmsAppUserPageParams>({
    startTime: dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
    endTime: dayjs().endOf("month").format("YYYY-MM-DD HH:mm:ss"),
    invitation: "",
    labelName: "",
    mobile: "",
    recommenderPhone: "",
    status: "",
    userId: "",
    ypageNum: 1,
    ypageSize: 10,
  });

  const [userOutFormData, setUserOutFormData] = useState({
    userId: "",
    ypageNum: 1,
    ypageSize: 10,
  });
  const [linkDetailOpen, setLinkDetailOpen] = useState(false);
  const [linkDetailData, setLinkDetailData] = useState([]);

  const [teamPerformanceDetailOpen, setTeamPerformanceDetailOpen] = useState(false);
  const [teamPerformanceDetailData, setTeamPerformanceDetailData] = useState([]);

  const [modalFormuserEdit, setModalFormuserEdit] = useState({
    avatar: [],
  });
  const defaultUserInfo = useRef<any>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>(null);

  const userEditFormTab = [
    {
      label: "头像",
      name: "avatar",
      type: "upload",
      labelCol1: { span: 0, offset: 3 },
      getValueFromEvent: normFile,
      params: {
        maxCount: 1,
        fileList: modalFormuserEdit.avatar,
        beforeUpload: () => {
          setMainPicUploadProgress(true);
        },
        uploadMessage: mainPicUploadProgress ? (
          <div>
            {setIcons("LoadingOutlined")}
            <div>上传中...</div>
          </div>
        ) : (
          <div>
            {setIcons("PlusOutlined")}
            <div style={{ marginTop: 8 }}>上传</div>
          </div>
        ),
        customRequest: async (e: any) => {
          try {
            const data = await customRequest(
              e,
              modalFormuserEdit.avatar as any[]
            );

            setModalFormuserEdit({
              ...modalFormuserEdit,
              avatar: data as any,
            });
          } catch (error) {
          } finally {
            setMainPicUploadProgress(false);
          }
        },
        onRemove: () => {
          setModalFormuserEdit({
            ...modalFormData,
            avatar: [],
          });
        },
      },
    },
    {
      label: "用户昵称",
      name: "nickName",
      type: "input",
      labelCol1: { span: 0, offset: 1 },
      rules: [
        { required: true, message: "请输入昵称" },
        { pattern: /^\S*$/, message: "不能包含空格" },
      ],
    },
    {
      label: "用户账号",
      name: "mobile",
      type: "input",
      labelCol1: { span: 0, offset: 1 },
      rules: [
        { required: true, message: "请输入用户账号" },
        { pattern: /^\S*$/, message: "不能包含空格" },
      ],
    },
    {
      label: "个性签名",
      name: "personalizedSignature",
      type: "textArea",
    },
    {
      label: "用户等级",
      name: "userLevel",
      type: "select",
      labelCol1: { span: 0, offset: 1 },
      options: providers_level,
    },
    {
      label: "合伙企业股东",
      name: "flowingShareholders",
      type: "radio",
      labelCol1: { span: 0, offset: 1 },
      options: flowingShareholders_options,
    },
    // {
    //   label: "状态",
    //   name: "userStatus",
    //   type: "radio",
    //   labelCol1: { span: 0, offset: 1 },
    //   options: [
    //     {
    //       label: "正常",
    //       value: "0",
    //     },
    //     {
    //       label: "用",
    //       value: "1",
    //     },
    //   ],
    // },
    {
      label: "用户类型",
      name: "userType",
      type: "radio",
      labelCol1: { span: 0, offset: 1 },
      options: [
        {
          label: "管理",
          value: "0",
        },
        {
          label: "普通",
          value: "1",
        },
      ],
    },
    {
      label: "是否可提现",
      name: "withdrawStatus",
      type: "radio",
      labelCol1: { span: 0, offset: 1 },
      options: [
        {
          label: "是",
          value: "0",
        },
        {
          label: "否",
          value: "1",
        },
      ],
    },
    {
      label: "用户类型",
      name: "userRegType",
      type: "radio",
      labelCol1: { span: 0, offset: 1 },
      options: [
        {
          label: "手机注册",
          value: 0,
        },
        {
          label: "邮箱注册",
          value: 1,
        },
      ],
    },
  ];



  const confirmChangeParent = async (val: any) => {
    try {
      await changeParent({ ...val, userId: userOutFormData.userId });
      message.success("推荐人变更成功");
      resetUserOut();
      getPageData();
      setuserOutOpen(false);
    } catch (error) {}
  };

  const footer = [
    // {
    //   title: "批量收益分佣",
    //   onClick: () => {
    //     editPriceForm.resetFields();
    //     setIsModalVisible(true);
    //   },
    //   // loading: exportLoading,
    //   disabled: selectedRowKeys.length === 0,
    //   type: "primary",
    // },
  ];

  useEffect(() => {
    getPageData();
    console.log(providers_level, "providers_level");
  }, [formData]);

  useEffect(() => {
    !providers_level && dispatch(dictInfoAsync("providers_level") as any);

    !account_changes_business_type &&
      dispatch(dictInfoAsync("account_changes_business_type") as any);
  }, []);

  const linkDetail = async (userId: string) => {
    const { data } = await getLinkDetail(userId);
    console.log(data, "data");
    setLinkDetailOpen(true);
    setLinkDetailData(data);
  };

  const stopSubsidy = async (userId: string) => {
    Modal.confirm({
      title: "停用",
      content: <div>是否停用当前选中用户补贴？</div>,
      onOk: async () => {
        // await appEditUser({...rows, userStatus: "1"})
        message.success("停用补贴成功");
        getPageData();
      },
    });
  };

  const getPageData = async () => {
    setLoading(true);
    setSearchLoading(true);
    try {
      const params: any = { ...formData };
      params.provinceId = params.channelName?.[0];
      params.cityId = params.channelName?.[1];
      params.districtId = params.channelName?.[2];
      const data = await appUserInfoList(params);
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
      setSearchLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({
      ...formData,
      ...val,
      ypageNum: 1,
    });
  };

  const reset = () => {
    setFormData({
      ...resetForm(formData),
      startTime: dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
      endTime: dayjs().endOf("month").format("YYYY-MM-DD HH:mm:ss"),
    });
    setSelectedRowKeys([]);
  };
  const resetModal = () => {
    setModalFormData({
      accountType: "3",
    });
    setOpen(false);
  };

  const resetUserOut = () => {
    setUserOutFormData({
      userId: "",
      ypageNum: 1,
      ypageSize: 10,
    });
    setuserOutOpen(false);
  };

  const confirmSend = async (val: any) => {
    try {
      setAddMoneyLoading(true);
      await appEditAccount({
        ...val,
      });
      message.success("金额变更成功");
      resetModal();
      getPageData();
    } catch (error) {
      console.log(error, "error");
    } finally {
      setAddMoneyLoading(false);
    }
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };

  const authDetail = async (val: any) => {
    let value = val.teamAttribute || "";
    Modal.confirm({
      title: "团队属性",
      content: (
        <PageTab
          formTab={[
            {
              label: "团队属性",
              name: "teamAttribute",
              type: "input",
              initialValue: value,
              rules: [{ required: true, message: "请输入团队属性" }],
              params: {
                onChange: (e: any) => {
                  value = e.target.value;
                },
              },
            },
          ]}
          showFooter={false}
        ></PageTab>
      ),
      onOk: async () => {
        if (value) {
          await editAppUserTeamAttribute({
            userId: val.userId,
            teamAttribute: value,
          });
        } else {
          message.error("请输入团队属性");
          throw new Error("请输入团队属性");
        }
      },
    });
  };

  const editAppUserTeamAttribute = async (val: any) => {
    await appEditAppUserTeamAttribute(val);
    message.success("团队属性变更成功");
    getPageData();
  };

  const outDetail = async (val: string) => {
    try {
      const { data } = await appDetail(val);
      setModalFormuserEdit({
        ...data,
        avatar: data.avatar
          ? [{ url: data.avatar, uid: data.avatar, name: "" }]
          : [],
      });
      defaultUserInfo.current = data;
      setEidtUserOpen(true);
    } catch (error) {}
  };
  const changeSubsidy = async (rows: { skipBuTie: number; userId: any }) => {
    const data = await showModal({
      title: "系统提示",
      content: (
        <div>是否{rows.skipBuTie === 1 ? "停用" : "启用"}当前用户补贴？</div>
      ),
    });
    if (data === "ok") {
      try {
        await editAppUserBuTie({
          type: rows.skipBuTie === 1 ? 0 : 1,
          userId: rows.userId,
        });
        message.success("用户补贴状态变更成功");
        getPageData();
      } catch (error) {}
    }
    // editAppUserBuTie()
  };

  const confirmUser = async (val: any) => {
    if (val.mobile !== defaultUserInfo.current.mobile) {
      Modal.confirm({
        title: "系统提示",
        content: <div>当前用户账号已变更，是否继续保存？</div>,
        onOk: async () => {
          await appEditUser({ ...val, avatar: val?.avatar?.[0]?.url });
          message.success("编辑成功！");
          setEidtUserOpen(false);
          getPageData();
        },
      });
      return;
    }
    try {
      await appEditUser({ ...val, avatar: val?.avatar?.[0]?.url });
      message.success("编辑成功！");
      setEidtUserOpen(false);
      getPageData();
    } catch (error) {}
  };

  const resetEditUser = () => {
    setEidtUserOpen(false);
    setModalFormuserEdit({
      avatar: [],
    });
  };

  const editPrice = (val: any) => {
    setCurrentRecord(val);
    setIsModalVisible(true);
  };

  const confirmPrice = async (values: any) => {
    try {
      await editAppUserDeviceFlowReward({
        ...values,
        userIds: selectedRowKeys,
      });
      message.success("分佣调整成功");
      setIsModalVisible(false);
      setSelectedRowKeys([]);
      getPageData();
    } catch (error) {
      console.error("验证失败:", error);
    }
  };

  const teamPerformanceDetail = (val: any) => {
    setTeamPerformanceDetailOpen(true);
    setTeamPerformanceDetailData(val);
  };

  return (
    <div>
      <Modal
        destroyOnHidden
        open={eidtUserOpen}
        title="编辑用户信息"
        width="24%"
        footer={<></>}
        onCancel={resetEditUser}
      >
        <PageTab
          subFoot
          search={confirmUser}
          reset={resetEditUser}
          formTab={userEditFormTab}
          initialValues={modalFormuserEdit}
        ></PageTab>
      </Modal>
      <Modal
        destroyOnHidden
        open={userOutopen}
        title="推荐人变更"
        width="380px"
        footer={<></>}
        onCancel={resetUserOut}
      >
        <PageTab
          subFoot
          search={confirmChangeParent}
          reset={() => {
            setuserOutOpen(false);
          }}
          formTab={[
            {
              label: "推荐人",
              name: "mobile",
              type: "input",
              rules: [
                { required: true, message: "请输入推荐人账号" },
                // {
                //   pattern: /^1[3-9]\d{9}$/,
                //   message: "请输入正确的手机号",
                // },
              ],
            },
          ]}
        ></PageTab>
      </Modal>
      <Modal
        destroyOnHidden
        open={open}
        title="添加金额"
        width="380px"
        footer={<></>}
        onCancel={resetModal}
      >
        <PageTab
          subFoot
          search={confirmSend}
          reset={resetModal}
          formTab={modalFormTab}
          initialValues={modalFormData}
          confirmLoading={addMoneyLoading}
        ></PageTab>
      </Modal>
      <Modal
        destroyOnHidden
        open={linkDetailOpen}
        title="链路详情"
        width="980px"
        footer={<></>}
        onCancel={() => {
          setLinkDetailOpen(false);
        }}
      >
        <div
          style={{ height: "500px", overflowY: "auto", overflowX: "hidden" }}
        >
          <PageTable
            // loading={loading}
            columns={linkColumns}
            data={linkDetailData}
          ></PageTable>
        </div>
      </Modal>

      <Modal
        width="380px"
        title="修改流水收益分佣"
        open={isModalVisible}
        destroyOnHidden
        footer={<></>}
        onCancel={() => {
          editPriceForm.resetFields();
          setIsModalVisible(false);
        }}
      >
        <PageTab
          form={editPriceForm}
          subFoot
          reset={() => {
            editPriceForm.resetFields();
            setIsModalVisible(false);
          }}
          search={confirmPrice}
          formTab={[
            {
              label: "收益类型",
              name: "deviceFlowRewardType",
              type: "select",
              options: [
                { label: "通用模式", value: "0" },
                { label: "自定义模式", value: "1" },
                { label: "不分佣", value: "2" },
              ],
              params: {
                onChange: (e: any) => {
                  console.log(e, "e");
                  editPriceForm.setFieldsValue({
                    deviceFlowRewardMin: "",
                    deviceFlowRewardMax: "",
                  });
                  setEditPriceDisabled(e !== "1");
                },
              },
            },
            {
              label: "收益最小值",
              name: "deviceFlowRewardMin",
              type: "input",
              params: {
                disabled: editPriceDisabled,
              },
              rules: [
                {
                  pattern: decimalReg,
                  message: "请输入正确数值",
                },
              ],
            },
            {
              label: "收益最大值",
              name: "deviceFlowRewardMax",
              type: "input",
              params: {
                disabled: editPriceDisabled,
              },
              rules: [{ pattern: decimalReg, message: "请输入正确数值" }],
            },
          ]}
          initialValues={currentRecord}
          // showFooter={false}
        />
      </Modal>

      <PageTab
        search={search}
        reset={reset}
        formTab={formTab(providers_level, cascaderProps)}
        // footer={footer}
        // footer={null}
        loading={searchLoading}
      ></PageTab>
      <PageTable
        loading={loading}
        pageChange={pageChange}
        size="small"
        rowKey="userId"
        columns={columns({
          providers_level,
          setOpen,
          setModalFormData,
          outDetail,
          stopSubsidy,
          setuserOutOpen,
          setUserOutFormData,
          changeSubsidy,
          linkDetail,
          authDetail,
          userOutFormData,
          editPrice,
          teamPerformanceDetail,
        })}
        data={pageData}
        pagination={{
          current: formData.ypageNum!,
          pageSize: formData.ypageSize!,
          total: total,
        }}
        selection={true}
        selectedRowKeys={selectedRowKeys}
        selectionChange={(selectedRowKeys: any, selectedRows: any) => {
          setSelectedRowKeys(selectedRowKeys);
        }}
      ></PageTable>
      <TeamPerformance
        open={teamPerformanceDetailOpen}
        onCancel={() => {
          setTeamPerformanceDetailOpen(false);
        }}
        data={teamPerformanceDetailData}
      />
    </div>
  );
};

export default AppUserInfo;
function ref<T>(arg0: null) {
  throw new Error("Function not implemented.");
}
